export default "__VITE_ASSET__KPoY_ii8__"